import { HighchartsChartModule } from 'highcharts-angular';
import { PipesModule } from '@techrules/pipelib';
import { TechDxdatagridComponent } from '../shared/tech-dxdatagrid/tech-dxdatagrid.component';
import { CustomMaterialModule } from '@tech-material';

import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';

import { NgxMaskModule } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { TechConfirmationDialogComponent } from '../shared/techconfirmationdialog/techconfirma_dialog.component';
import { TechErrorDialogComponent } from '../shared/techerrordialog/techerror_dialog.component';
import { TechDialogsService } from '../shared/tech-dialogs.service';
import { TechSnackbarComponent } from '../shared/techsnackbar/techsnackbar.component';
import { TechModalDialogComponent } from '../shared/techmodaldialog/techmodaldialog.component';
import { TechModalRiskProfileExpireComponent } from '../shared/techmodalRiskProfileExpire/techmodalRiskProfileExpire.component';
import { ModalCustomDateComponent } from '../shared/modal-custom-date/modal-custom-date.component';
import { TechDatagridComponent } from '../shared/techdatagrid/techdatagrid.component';

import { LoadingPeqComponent } from '../areas/ui/loading-peq/loading-peq.component';
import { LoadingScreenComponent } from '../areas/ui/loading-screen/loading-screen.component';
import { LoadingThinkingComponent2 } from '../areas/ui/loading-thinking2/loading-thinking.component';

import { ProcesslineComponent } from '../areas/ui/processline/processline.component';

import {
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaV3Module,
} from 'ng-recaptcha';
//import appSettings from 'src/assets/AppSetting.json';
import { BlackMessageComponent } from '../areas/ui/black-message/black-message.component';
import { CountSpanComponent } from '../areas/ui/count-span/count-span.component';
import { AutonumericModule } from '@angularfy/autonumeric';
import { AwesomeModule } from './awesome.module';
import { TimeAgoPipe } from '../core/pipes/timeago/timeago.pipe';

import { QuestionsResult2Component } from '../shared/questions-result2/questions-result2.component';
import { ModalCustomDateReportComponent } from '../shared/modal-custom-date-report/modal-custom-date-report.component';
import { PortfolioItemComponent } from '../areas/ui/portfolio-item/portfolio-item.component';
import { CriteriaComponent } from '../areas/ui/laboratory/criteria/criteria.component';
import { AssetItemComponent } from '../areas/ui/laboratory/asset-item/asset-item.component';
import { TechScoreComponent } from '../areas/ui/laboratory/tech-score/tech-score.component';
import { CustomDevextremeModule } from './devextreme.module';
import { TechModalDialogResendComponent } from '../shared/techmodaldialogresend/techmodaldialogresend.component';
import { TechBackComponent } from '../shared/tech-back/tech-back.component';
import { ModalCustomDateTradesComponent } from '../shared/modal-custom-date-trades/modal-custom-date-trades.component';
import { ModalCustomAccountStatementComponent } from '../shared/modal-custom-account-statement/modal-custom-account-statement.component';

const Commons = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  CustomMaterialModule,
  HttpClientModule,
  AwesomeModule,
  RecaptchaV3Module,
  RecaptchaModule,
  RecaptchaFormsModule,
  PipesModule,
  HighchartsChartModule,
  CustomDevextremeModule,
  ClipboardModule,
  NgxQRCodeModule,
];

const APP_PIPES = [TimeAgoPipe];

const APP_DIALOGS = [
  TechConfirmationDialogComponent,
  TechErrorDialogComponent,
  TechModalDialogComponent,
  TechModalRiskProfileExpireComponent,
  TechModalDialogResendComponent,
  TechSnackbarComponent,
  ModalCustomDateComponent,
  ModalCustomDateReportComponent,
  ModalCustomDateTradesComponent,
  ModalCustomAccountStatementComponent,
];

@NgModule({
  id: 'tech-shared-module',
  declarations: [
    ...APP_DIALOGS,
    ...APP_PIPES,
    TechDatagridComponent,
    TechDxdatagridComponent,
    LoadingPeqComponent,
    LoadingScreenComponent,
    LoadingThinkingComponent2,
    ProcesslineComponent,
    BlackMessageComponent,
    CountSpanComponent,
    QuestionsResult2Component,
    PortfolioItemComponent,
    CriteriaComponent,
    AssetItemComponent,
    TechScoreComponent,
    TechBackComponent,
  ],
  imports: [
    ...Commons,
    NgxMaskModule,
    TranslateModule,
    AutonumericModule.forRoot(),
  ],
  exports: [
    ...Commons,
    ...APP_DIALOGS,
    ...APP_PIPES,
    TechDatagridComponent,
    TechDxdatagridComponent,
    LoadingPeqComponent,
    LoadingScreenComponent,
    LoadingThinkingComponent2,
    ProcesslineComponent,
    BlackMessageComponent,
    CountSpanComponent,
    AutonumericModule,
    QuestionsResult2Component,
    PortfolioItemComponent,
    CriteriaComponent,
    AssetItemComponent,
    TechScoreComponent,
    TranslateModule,
    TechBackComponent,
  ],
  providers: [DatePipe, TechDialogsService],
})
export class SharedModule {}
